(ns renolit-roofing-service.layout.icon)

(def ^:const myna-ui-icon-mapping
  {:logout "logout"
   :home "home"
   :reward "gift"
   :history "clock-circle"
   :notification-bell "bell"
   :profile "user-circle"
   :add-user "add-queue"
   :info "info-circle"
   :edit-one "edit-one"
   :delete "trash"
   :add "plus"
   :warning "danger-triangle"
   :success "check-circle"
   :error "minus-circle"
   :flask "flask"
   :indicator-hide "chevron-down"
   :indicator-show "chevron-up"
   :search "search"
   :expand-more "chevron-down"
   :close "x"
   :airplane "aeroplane"
   :list "list"
   :right-arrow "arrow-right"
   :back "arrow-left"
   :request-blocked "lock-circle"
   :request-requested "check-circle"
   :request-sent "send"
   :request-preparing "package"
   :resources-and-support "gift"
   :training "academic-hat"
   :product "package"
   :experience "building"
   :merchandising "shopping-bag"
   :confetti "confetti"
   :sort "sort"
   :export "download"
   :eye "eye"
   :eye-slash "eye-slash"
   :package "package"
   :dots-vertical "dots-vertical"
   :book-check "book-check"
   :question-circle "question-circle"
   :envelope "envelope"
   :menu "menu"
   :edit "edit"
   :comment "chat"
   :cancel "x-circle"
   :circle "circle"
   :square "square"
   :triangle "triangle"
   :message "message"
   :filter "filter"
   :location "location"
   :map "map"
   :camera "camera"
   :file "file"})

(defn icon
  [{:keys [key class clickable? disabled? props rounded? solid?]}]
  (let [icon-key (get myna-ui-icon-mapping key)
        icon-class (str "mynaui-" (when solid? "solid-") icon-key)]
    [:span.icon
     (merge
      {:class (cond-> [icon-class]
                (string? class) (conj class)
                (coll? class) (concat class)
                disabled? (conj "icon--disabled")
                clickable? (conj "icon--clickable")
                rounded? (conj "icon--rounded"))}
      props)]))
